<template>
    <div>
        <div :style="{bottom:displayInputBottom}" class="input-box">
            <input class="message-input" v-model="text" :disabled="!isTimReady" :placeholder="isTimReady?'我想问主播...':'初始化中，请稍等'" placeholder-style="color:#fff;font-size:$fontSize" type="text" />
            <div class="common-btn ds-button-small submit" @click="confirm()">发送</div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    isTimReady: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: '',
      displayInputBottom: '0px'
    }
  },
  methods: {
    confirm () {
      this.$emit('send-message', this.text)
      this.text = ''
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
    .input-box{display: flex;}
    .message-input {
        height: 1.35rem;
        width: 4.7671875rem;
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        padding-left: 0.421875rem;
        padding-right: 0.421875rem;
        line-height: 1.35rem;
        border: 0;
        outline: none;
        font-size:$fontSize;
        color: #fff;
        background: none;
    }
    .submit{margin-left: auto;}
</style>
